.calendarWrapper {
  z-index: 999;
  box-shadow: 0 2px 15px var(--paletteNeutral3);
}

.displayInBadge {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.date {
  display: flex;
  align-items: center;
  column-gap: var(--spacingXs);
}

.calendarButton {
  height: fit-content;
  padding: var(--spacingXs) var(--spacingSm);

  &:active,
  &:focus-visible {
    outline: none;
    border: 1px solid var(--paletteBlue0);
    box-shadow: inset 0 0 0 1px var(--paletteBlue0);
  }
}

.rightContentRoot {
  padding-right: var(--spacingMd);
}
